import {useState} from 'react';
import Tour from './Tour';

const Main=()=>{

  return(
    <Tour/>
  );

}

export default Main;
